<template>
  <el-dialog class="scrolling" title="" :visible.sync="isAgreeVisible" width="70%">
    <div slot="title">
      <p style="line-height: 24px;font-size: 18px;color: #303133;">营客通自营供应商注册服务协议</p>
      <p v-if="contractCode" style="font-size:16px;color: #666;">协议编号：{{ contractCode }}
      </p>
    </div>
    <el-tabs>
      <!-- <el-tab-pane label="集市协议">
          <p style="line-height: 25px;height: 350px;overflow-y:scroll">
            <strong>集市入驻服务协议</strong> <br />
            欢迎您与集市平台经营者上海赢可通信息科技有限公司（“集市平台经营者”）共同签署本《集市入驻服务协议》（下称“本协议”）并使用集市平台服务（定义见下文）。 <br /><br />

            您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可向集市平台客服咨询。<br /><br />

            当您按照注册页面提示填写信息、阅读并同意本协议且完成全部入驻注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与集市平台经营者达成一致，成为集市平台“商户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止入驻注册程序。<br />
            <strong>一、定义</strong> <br /><br />
            集市平台：指营客通App客户端-集市板块。 <br />
            集市平台服务：集市平台经营者基于互联网，以包含营客通App客户端-集市板块、附近的店小程序等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务，包括但不限于店铺管理、商品发布、信息交流以及其他等有偿或无偿的服务。
            <br />
            集市平台规则：包括在所有集市平台中已经或将来可能发布的全部规范性文件，包括但不限于集市平台经营者于集市平台发布的各类规则、实施细则、产品流程说明、公告等。 <br />
            商户：指集市平台有效注册商户。 <br />
            买家：指在集市电商平台上浏览或购买商品的商户。 <br />
            卖家：指在集市电商平台上发布或出售商品的商户，也称“供应商”。 <br />


            <strong> 二、协议范围 </strong><br /><br />
            <strong>2.1 签约主体</strong><br />
            本协议由您与上海赢可通信息科技有限公司-即集市平台经营者共同缔结，本协议对您与上海赢可通信息科技有限公司均具有合同效力。<br />
            为免疑义，本协议项下，集市平台经营者可能根据集市平台的业务调整而发生变更，变更后的集市平台经营者与您共同履行本协议并向您提供服务，集市平台经营者的变更不会影响您本协议项下的权益。集市平台经营者还有可能因为提供新的集市平台服务而新增，如您使用新增的集市平台服务的，视为您同意新增的集市平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。<br />
            <strong>2.2补充协议</strong> <br />
            由于互联网高速发展，您与集市平台经营者签署的本协议列明的条款并不能完整罗列并覆盖您与集市平台经营者的所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，集市平台隐私权政策、法律声明、集市平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用集市平台服务，视为您同意上述补充协议。<br />

            <strong>三、供应商账户注册与使用</strong><br /><br />

            <strong>3.1 商户资格</strong><br />
            您确认，在您开始注册程序使用集市平台服务前，您应当持续地满足以下条件：<br />
            (1) 您已依照中华人民共和国法律注册并领取合法有效的营业执照及取得其他经营许可；<br />
            (2) 您所经营的商品来源合法，资质齐全；<br />
            (3) 您提交的任何信息均真实、合法、有效，所使用的图片、文字等不侵犯任何第三方合法权益；<br />
            (4) 营客通依据国家法律法规、政策或其他规范性文件规定要求您具备的其他条件。<br />
            (5) 您已取得所销售的产品，在指定销售地的合法销售权利。<br /><br />
            <strong>3.2 证明文件</strong><br />
            您应当依据集市平台规则以及相应的入驻注册流程，在线签订平台公示的入驻协议，须向平台提交各项必须的资质、证照、证明或其他相关文件（以下统称“证明文件”），包括但不限于三证合一（营业执照、税务登记证、组织机构代码）、开户行证明、授权委托书、商标注册证、质检报告、法定代表人身份证复印件、与家电厂商签订的准许代理售卖协议等，且须向平台提交与原件核对一致并加盖公章的纸质复印件（根据实际业务提供相应资质）。<br />
            集市平台经营者会对您提供的如上真实信息进行核验、登记，并定期核验更新，因此您应当保证上述证明文件发生任何变更或更新时立即通知集市平台经营者，提交更新后的文件进行相应认证。<br />
            您提交虚假、过期文件或未及时通知并提交更新文件等情形的，应独立承担全部法律责任。您提交的信息不符合集市平台公示要求的，集市平台经营者会一次性通知您补齐相关资料，若您拒绝，集市平台经营者有权调整您的相关权限，直至终止本协议，若因此造成集市平台经营者及任何第三方损失，应承担全部责任与赔偿。
            <strong>3.2入驻保证金（补充）</strong><br /><br />
            3.2.1 0元开店<br />
            目前集市扶持新入驻商户，对供应商在平台新入驻阶段设置保护期：<br />
            1.试运营阶段不需要支付保证金。<br />
            2.结算周期为确认收货3个工作日内，通常是每周二、每周五根据真实物流签收进程结算。<br />
            3.试运营期为90个自然日。<br /><br />
            3.2.2 试运营达标补缴保证金<br />
            试运营期间，若商家店铺满足以下任一条件则试运营结束，应进入正式运营期，须在15个自然日内缴纳，或从货款中冻结足额保证金：<br />
            1.试运营满90个自然日；<br />
            2.店铺累计销售额≥100万元；<br />
            3.平台介入投诉单≥1单；<br />
            4.增开非试运营的类目，如综合经营（同时小家电开大家电）。<br />
            入驻保证金标准如下：<br />
            <span class="table2">
              <table>
                <tr>
                  <th>类目</th>
                  <th>试运营期间剔除退款的店铺成交金额(元)</th>
                </tr>
                <tr>
                  <td rowspan="3">综合</td>
                  <td> N＜100,000 </td>
                </tr>
                <tr>
                  <td>100,000≤N≤1,000,000 </td>
                </tr>
                <tr>
                  <td>N＞1,000,000 </td>
                </tr>
              </table>
            </span>
            3.2.3 试运营结束管控<br />
            试运营期结束后，若商家未及时足额缴纳或货款不足以冻结足额保证金，将视采取下列一项或多项管控措施：<br />
            （一）全店商品下架；<br />
            （二）禁止上架待售商品；<br />
            （三）限制创建商品；<br />
            （四）屏蔽店铺。<br /><br />
            3.2.4 终止合作机制<br />
            第一条 自然终止：店铺服务期届满，商家未完成续签的；<br />
            第二条 被动终止：店铺因违规行为被营客通清退。<br />
            第三条 提前终止：未到店铺服务结束日期，主动退出并提前关店的，终止协议操作步骤请见下文；<br />
            第四条 保证金<br />
            第五条 操作流程<br />
            （一）发起申请<br />
            服务协议终止且服务协议所约定的特定店铺所有订单终止、所有争议及索赔已处理完毕、已完成交易的商品质保期届满后，商家向客服发起保证金退还申请，在不出现“未支付的收付费单”等异常情况提醒的前提下，保证金将在在线申请退保证金完成（包括店铺销售品类质保期已满，结算完成等条件）后，退还到商家后台维护且验证通过的银行账户中<br />
            1．按合同约定，提前终止合作的商家不退还该店铺未到期部分对应的平台使用费。请仔细考虑后再申请退店。<br />
            2．根据《电子商务法》要求，电商平台第三方商家在退出平台前，需要提前30天面向消费者说明关店事宜。招商人员审核您的退店申请后，即进入公示期中，请您耐心等候。<br />
            3．公示期内所售出的商品，会正常计入商家关店后的保证金退款质保周期。为了能够尽快完成保证金退款流程，建议您在退店审核通过后及时对商品进行下架处理。<br />
            本次申请完成后，您的店铺关闭、商品全部下架且自关店同主体6个月内不允许再次入驻，请慎重考虑！<br />
            （二）等待审核<br />
            招商人员将在7个工作日内审核您的退出申请，审核期间如有任何问题，我们会随时联系系统中的店铺负责人，请确保信息正确。审核通过后会短信通知店铺负责人。在审核通过之前商家可随时取消申请。<br />
            （三）退出完成<br />
            审核通过，店铺进入公示期，公示期根据店铺实际情况为3-6个月不等，公示期结束店铺自动关闭，期间不可取消退店申请。店铺关闭后会短信通知店铺负责人。<br />
            商家退出营客通集市平台时，店铺保证金会在退店后退还给商家，一般是3-4个工作日到账。<br /><br />

            <strong>3.3账户说明</strong><br />
            3.3.1您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，可获得集市平台账户并成为集市平台商户。<br />
            3.3.2您有权使用您设置或确认的集市会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录集市平台。<br />
            3.3.3由于商户账户关联商户信用信息，仅当有法律明文规定、司法裁定或经集市平台经营者同意，并符合集市平台规则规定的商户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切责任均由您承担。<br /><br />

            <strong>3.4 注册信息管理</strong><br />
            3.4.1 真实合法<br />
            使用集市平台服务时，您应当按集市平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便集市平台经营者或下单客户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。否则，您将自己承担由此产生的所有责任和纠纷。<br />
            3.4.2 更新维护<br />
            如集市平台经营者按您最后一次提供的信息与您联系未果、或您未按集市平台经营者的要求及时提供信息、您提供的信息存在不实的，您将承担因此对您自身、他人及集市造成的全部损失与不利后果。<br /><br />

            <strong>3.5 账户安全规范</strong><br />
            您的账户为您自行设置并由您保管，集市平台经营者任何时候均不会主动要求您提供您的账户。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开集市平台。<br />
            账户因您主动泄露或遭受他人攻击、诈骗等行为导致的损失、纠纷及后果，营客通经营者并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。<br />
            除集市平台经营者存在明显过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。<br />
            如发现任何未经授权使用您账户登录集市平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知集市平台经营者。您理解集市平台经营者对您的任何请求采取行动均需要合理时间，集市平台经营者不承担任何责任。<br /><br />

            <strong>3.6 账户转让</strong><br />
            由于您的账户关联商户信用信息，仅当有法律明文规定、司法裁定或经集市平台经营者同意，并符合集市平台规则规定的账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则集市平台经营者有权追究您的违约责任，且由此产生的相应责任均由您承担。<br /><br />


            <strong>四、集市平台服务及规范</strong><br /><br />

            您有权在集市平台上享受店铺管理、商品及/或服务的销售与推广、商品及/或服务的购买与评价等服务。集市提供的服务内容众多，具体您可登录集市平台浏览。<br /><br />

            <strong>4.1 店铺管理</strong><br />
            通过在集市平台提供的集市模块下创建店铺，您可发布商品及/或服务信息并与其他商户达成交易。基于管理需要，您理解并认可，同一商户在集市平台仅能开设一家店铺，集市可关闭您同时开设的其他店铺。<br />
            由于店铺与账户的不可分性，店铺转让实质为店铺经营者账户的转让，店铺转让的相关要求与限制请适用本协议第3.6条账户转让条款。<br />
            如您通过下架全部产品短暂关停您的店铺，您仍应当对您店铺关停前已达成的交易继续承担发货、纠纷及投诉处理等交易保障责任。<br /><br />

            <strong>4.2商品及/或服务的销售与推广</strong><br /><br />
            4.2.1通过集市平台经营者提供的服务，您有权通过文字、图片、视频、音频等形式在集市平台上发布商品及/或服务信息，内容包括品名、规格、等级、计价单位、产地、价格等，以招揽和物色交易对象、达成交易。<br />
            4.2.2您应当确保您对您在集市平台上发布的商品及/或服务享有相应的权利，您不得在集市平台上销售以下商品及/或提供以下服务：<br />
            （一）国家禁止或限制的；<br />
            （二）侵犯他人知识产权或其它合法权益的；<br />
            （三）集市平台规则或各平台与您单独签署的协议中已明确说明不适合在集市平台上销售及/或提供的。<br />
            4.2.3您应当遵守诚实信用原则，有义务确保在集市平台销售的商品按照国家标准、行业而标准以及平台发布的各类商品要求进行质量控制（包括但不限于商品法律法规符合性、商品安全性、商品功能材质与描述符合性、商品标识标示、商品外观，商品包装等），并依照国家法律法规提供售后三包服务。集市平台有权根据市场反馈自行或委托第三方质检机构进行不定期商品抽检（检测项目包括但不限于销售商品的性能、质量、材料成分等；抽检方式包括但不限于匿名购买、对于买家订单信息及页面信息进行检查等）或要求您对集市平台指定商品提供进货凭证，出厂检验报告等相关商品及批次的质量合格证明文件。集市平台经营者有权依据抽检结果反映的问题以及问题的严重程序对您提出相应的限期整改要求，违规处理以及追究违约责任。<br />
            4.2.4您应当维护集市平台市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰集市平台上进行的任何交易、活动，不得以任何不正当方式提升或试图提升自身的信用度，不得以任何方式干扰或试图干扰集市平台的正常运作。<br />
            4.2.5您有权自行决定商品及/或服务的促销及推广方式，集市平台亦为您提供了形式丰富的促销推广工具。您的促销推广行为应当符合国家相关法律法规及集市平台的要求。<br /><br />
            4.3店铺评价<br />
            您在集市平台提供的评价系统中收到的与您达成交易的买家的评价，不得随意自行删除。<br /><br />
            4.4平台服务费、店铺款项及税收<br />
            4.4.1您应同意并授权集市平台经营者通过与银联或合作银行签订的监管分账形式，由银行独立监管账户代您收取买家支付的货款。依据您与买家确认的结算流程，自买家确认收货后的3个工作日后，银行监管账户会将货款将结算至您的账户。集市平台经营者向您收取平台服务费用，冰、空、彩、洗四大品类按总价款1.5%收取，其他品类按总价款5%-10%收取，平台服务费用将在货款结算中予以直接扣除。<br />
            4.4.2依法纳税是每一个公民、企业应尽的义务，您应对销售额/营业额超过法定免征额部分及时、足额地向税务主管机关申报纳税，并且有义务按照买家实际支付的金额，按其要求开具发票。<br />


            <br /><strong>五、商户信息的保护及授权</strong><br /><br />

            <strong>5.1个人信息的保护</strong><br />
            集市平台经营者非常重视商户个人信息（即能够独立或与其他信息结合后识别商户身份的信息）的保护，在您使用集市提供的服务时，您同意集市平台经营者按照在集市平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。集市平台经营者希望通过隐私权政策向您清楚地介绍集市平台经营者对您个人信息的处理方式，因此集市平台经营者建议您完整地阅读隐私权政策（点击此处或点击集市平台首页底部链接），以帮助您更好地保护您的隐私权。<br /><br />

            <strong>5.2非个人信息的保证与授权</strong><br />
            您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，集市平台经营者可对您发布的信息依法或依本协议经通知后可进行删除或屏蔽。<br />
            您应当确保您所发布的信息不包含以下内容：<br />
            （一）违反国家法律法规禁止性规定的；<br />
            （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；<br />
            （三）欺诈、虚假、不准确或存在误导性的；<br />
            （四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；<br />
            （五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；<br />
            （六）存在可能破坏、篡改、删除、影响集市平台任何系统正常运行或未经授权秘密获取集市平台及其他商户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；<br />
            （七）其他违背社会公共利益或公共道德或依据相关集市平台协议、规则的规定不适合在集市平台上发布的。<br />

            <br /><strong>六、店铺卖家的违约处罚</strong><br /><br />
            <strong>6.1发生如下情形之一的，视为您违约：</strong><br />
            （一）使用集市平台服务时违反有关法律法规规定的；<br />
            （二）销售货品与描述不符的，包括但不限于品牌、型号、产品功能、产品参数。<br />
            （三）违反本协议或本协议补充协议约定的。<br />
            为适应电子商务发展和满足海量商户对高效优质服务的需求，您理解并同意，集市平台经营者可在集市平台规则中约定违约认定的程序和标准。如：集市平台经营者可依据您的商户数据与海量商户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。<br />

            <strong>6.2 违约处理措施（补充）</strong><br />
            6.2.1您在集市平台上发布的信息构成违约的，集市平台经营者可根据相应规则立即对相应信息经通知后进行删除、屏蔽处理或对您的商品进行下架、监管。<br />
            6.2.2您在集市平台上实施的行为，或虽未在集市平台上实施但对集市平台及其商户产生影响的行为构成违约的，集市平台经营者可依据相应规则中止向您提供部分或全部服务、从保证金账户或货款中划扣违约金等处理措施。<br />
            6.2.3若您有销售假冒伪劣商品等侵犯知识产权行为、涉嫌非法信用卡套现等违法活动，并有可能涉嫌刑事犯罪的，集市平台经营者有权向相应机关（包括但不限于行政监管机关、公安机关、司法机关以及其他有权机关）提供您一切资料与信息，并配合相应机关的调查取证和侦查工作。<br />
            6.2.4 发货违规（补充）<br />
            第一条 违规情形包括但不限于：虚假发货、延迟发货、未发货订单积压、缺货无货、拒绝发货、少件、错件、未按照要求使用发货方式等。<br />
            第二条 处理措施：营客通有权视违规程度对店铺执行扣除违约金、下架违规商品和限售等处理措施。营客通有权依据协议等，根据商家违规程度，对商家采取如下处理：<br />
            <span class="table1">
              <table>
                <tr>
                  <th>违规情形</th>
                  <th>具体处理措施</th>
                </tr>
                <tr>
                  <td style="width: 200px;">虚假发货</td>
                  <td> 每单扣除订单金额2%，下限20元上限100元，对应商品下架处理。 </td>
                </tr>
                <tr>
                  <td>延迟发货 </td>
                  <td>
                    商家在商品订单承诺发货时效内仍未完成揽件的订单（>承诺揽收时效），营客通有权直接从商家钱包账户（包括钱包、货款、保证金等）中扣除对应的客户赔付金1%（下限20元上限100元），并将同等金额以盟友豆/平台补偿券的形式发放给延迟发货订单所对应的消费者。
                  </td>
                </tr>
                <tr>
                  <td>延迟发货并有客诉</td>
                  <td>商家实际发货时效比承诺揽收时效晚72小时并引起客户投诉 平台介入处理
                    1. 平台扣除供应商该订单金额的1.5%（下限20元上限100元）作为未能履行订单的罚款
                    2.根据客户诉求①继续发货（换采）给用户固定金额的优惠券/返豆 ②取消订单并补偿给用户固定金额的优惠券/返豆 </td>
                </tr>
                <tr>
                  <td>未发货订单积压</td>
                  <td>营客通有权根据未发货订单积压情况对全店商品进行限售。</td>
                </tr>
                <tr>
                  <td>缺货无货/拒绝发货</td>
                  <td>严重超期未发货时采取按订单金额的1%扣除违约金（下限20元上限100元），商品下架处理。</td>
                </tr>
                <tr>
                  <td>少件、错件</td>
                  <td>严重少错件时采取按订单金额的2%扣除违约金（下限20元上限100元），商品下架处理。</td>
                </tr>
              </table>
            </span>
            一、虚假发货：<br />
            营客通认定虚假发货的情形包括但不限于：<br />
            商家上传物流运单号的地址与订单的实际收货地址不同；<br />
            商家上传的物流运单号已经被其他订单使用；<br />
            上传的物流运单号对应的收到的货物与实际购买订单货物不符【（拍A发B：特指收到的货物与实际购买的完全不一致，不包含品牌问题、商品宣传问题）、赠品、空包】；<br />
            商家上传的物流单号与实际发货的物流单号不符；<br />
            针对以上虚假发货的情况一经核实予以处罚，每单扣除订单金额2%，下限20上限100元，对应商品下架处理。<br />
            二、延迟发货：<br />
            是指商家设置商品的承诺发货时效后，未按时效完成揽件的情形，揽件是指商家在承诺发货时效内，上传订单对应的物流单号至营客通平台并有物流公司揽件信息。<br />
            三、未发货订单积压<br />
            商家在经营过程中，所售商品量超出自身发货能力，造成未发货订单积压时，营客通有权视积压程度对全店所有商品进行限售。<br />
            轻度积压：按商家承诺应揽件日期（Promise），日订单量>10单时若后续超承诺24小时未揽件订单占比≥10%，或近30天累计超承诺24小时未揽件订单量>20单，则管控触发，对全店所有商品全区域限售24小时。<br />
            重度积压：按商家承诺应揽件日期（Promise），日订单量>30单时若后续超承诺72小时未揽件订单占比≥20%，或近30天累计超承诺72小时未揽件订单量>50单，则触发管控，对全店所有商品全区域限售72小时。<br />
            四、缺货无货/拒绝发货<br />
            营客通认定缺货无货/拒绝发货的情形包括但不限于：<br />
            1.商家订单超过承诺应揽件日期7天仍未揽件的；<br />
            2.商家承认缺货无货/要求加价发货的；<br />
            3.消费者付款成功后，如双方无其它约定，商家拒绝按照消费者下单的价格交易或履行发货义务的（简称“拒绝发货”）。<br />
            针对缺货无货/拒绝发货场景，如引起消费者投诉或违规程度严重的，营客通有权采取对应商品下架处理；此外，缺货无货/拒绝发货包括商品属性、规格、价格等信息标错所导致未能履行承诺发货的，并且包括商家未在规定时间内处理完成或因处理不当导致大量客诉的订单。<br />
            针对严重超期未发货订单，在订单超过商家承诺应揽件日期（Promise）7天仍未揽件时，营客通将按照订单实际金额1%进行处罚，最低20元，最高100元。此外，违规商家仍需要按相关要求积极处理消费者投诉问题。（如果订单已经产生过缺货无货/拒绝发货情形赔付，商家需与消费者联系协商解决）<br />
            五、少件<br />
            商家未按照订单明细和网页商品描述或者商品实际重量/配件等打包发送订单商品，消费者投诉收到的订单商品存在少配件、少赠品，少商品的（简称“少件”）。如引起消费者投诉或违规程度严重的，营客通有权按照订单实际金额2%扣划违约金，最低20元，最高100元，并下架对应商品。<br />
            六、错件<br />
            商家在非主观恶意的情况下，给消费者发送的商品与达成交易时的订单商品不一致，特指同一商品物理属性问题，如：尺码、尺寸或颜色等。如引起消费者投诉或违规程度严重的，营客通有权按照订单实际金额2%扣划违约金，最低20元，最高100元，并下架对应商品。<br />

            6.2.5 不合规交易（补充）<br />
            用户在平台的交易行为受到保护，不允许供应商和用户在集市店铺平台外发生交易，商家将用户在营客通平台提交的订单引导至商家自有平台或其他合作平台交易的行为，包括不限于商家未告知平台通过其他途径直接联系平台用户、商家有意向引导用户至其自有平台或其他合作平台交易但未成功交易的行为，简称为飞单行为。<br />
            飞单常见违规场景<br />
            【常见违规场景1】<br />
            用户咨询期间/用户下单支付后，商家以各种不合理理由拒绝对在平台上架的商品/服务进行发货，引导用户按照订单金额或低于订单金额进行其他方式支付。<br />
            【常见违规场景2】<br />
            用户咨询期间/用户下单支付后，商家以各种不合理理由拒绝对在平台上架的商品/服务进行发货，引导用户退货去第三方平台直接下单购买。<br />
            【常见违规场景3】<br />
            用户咨询期间/用户下单支付后，商家引导用户使用商家其他优惠方式替代平台商品/服务支付消费款项。<br />
            【常见违规场景4】<br />
            用户咨询期间/用户下单支付后，商家提供其他更为优惠的方案引导用户使用非平台方式支付消费款项。<br />
            【常见违规场景5】<br />
            用户下单支付后，商家获取用户信息，通过微信、电话等途径，直接联系用户，引导平台外的交易行为。<br />
            <span class="table3">
              <table>
                <tr>
                  <th>轻微（无实际产生飞单行为，有诱导行为）</th>
                  <th>具体处理措施</th>
                </tr>
                <tr>
                  <td style="width: 200px;">轻微（无实际产生飞单行为，有诱导行为）</td>
                  <td>扣除履约保证金1000元，全店所有商品下架，3日内补充保证金至5000元，出具守约承诺书，平台审核完毕产品上架</td>
                </tr>
                <tr>
                  <td>一般（产生1-2次飞单行为）</td>
                  <td>扣取履约保证金2000元，退店</td>
                </tr>
                <tr>
                  <td>极其严重（产生3次及以上飞单行为）</td>
                  <td>退店，3日内向平台缴纳50000元违约金，如不按期缴纳，平台有权扣除未结算的等额货款，并保留追究造成其他损失的权利</td>
                </tr>
              </table>
            </span>

            <strong>6.3赔偿责任</strong><br />
            如您的行为使集市平台经营者或买家遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿集市平台经营者或买家的上述全部损失。如您的行为使集市平台经营者遭受第三人主张权利，集市平台经营者可在对第三人承担金钱给付等义务后就全部损失向您追偿。在集市平台经营者接到买家投诉、法律诉讼等可能遭受损失时，集市平台经营者有权扣押、或扣除您的货款。<br />
            对于所销售的商品，若违反6.1（二）销售货品与描述不符的，卖家对集市平台经营者和买家承担无限期的赔偿责任。<br />
            <strong>6.4公示</strong><br />
            集市平台经营者可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在集市平台上予以公示。<br />
            <strong>6.5特别约定</strong><br />
            6.5.1如您向集市平台经营者的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，集市平台经营者可立即终止与您的所有合作并向您收取违约金或赔偿金，该等金额以集市平台经营者因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。<br />
            6.5.2如您因违约导致集市平台经营者终止本协议时，出于维护平台秩序以及保护其他商户合法权益的目的，集市平台经营者可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以协议约定的方式通知您。<br />
            6.5.3卖家自行监管自己商品的销售地、商品的安装地。如果因发生串货行为，而受到商户上游厂家责罚，与集市平台经营者无关。<br />
            6.5.4卖家自行控制销售价格，若因与厂家签订过价格约定，涉及到厂家判定卖家乱价，造成的任何厂家对卖家的惩罚，由卖家自行承担。<br />

            <br /><strong>七、责任限制</strong><br /><br />

            <strong>7.1集市平台经营者依照法律规定履行基础保障义务，但对于下述不可抗力或其他第三人因素原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，集市平台经营者并不承担相应的违约责任：</strong><br />
            （一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br />
            （二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；<br />
            （三）在集市平台经营者已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。<br />

            <strong>7.2集市平台经营者仅向您提供本协议约定之服务，您了解集市平台上的信息系商户自行发布，且可能存在风险和瑕疵。同时，鉴于集市平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，集市平台作为网络交易平台无法逐一审查产品及/或服务的信息，无法逐一审查交易所涉及的产品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断，如发现存在危害信息和行为，请您及时同集市平台经营者进行联系和投诉，集市平台将对有害信息和行为进行处理。</strong><br />

            <br /><strong>八、协议的变更</strong><br /><br />

            集市平台经营者可根据国家法律法规变化及维护交易秩序需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第八条约定的方式通知您。<br />
            如您不同意变更事项，您有权于变更事项确定的生效日前联系集市平台经营者反馈意见。如反馈意见得以采纳，集市平台经营者将酌情调整变更事项。<br />
            如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用集市平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用集市平台服务，则视为您同意已生效的变更事项。<br />

            <br /> <strong>九、通知</strong><br /><br />

            <strong>9.1您在注册成为集市平台用户，并接受集市平台服务时，您应该向集市平台经营者提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被有效联系的状态。</strong><br />

            <strong>9.2 您同意集市平台经营者以以下合理的方式向您送达各类通知：</strong><br />
            （一）公示的文案；<br />
            （二）站内信、客户端推送的消息；<br />
            （三）根据您预留于集市平台的联系方式发出的电子邮件、短信、函件等。<br />
            集市平台经营者将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。<br />

            <strong>9.3 通知的送达</strong><br />
            9.3.1集市平台经营者通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在集市平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账户发送站内信信息、系统消息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。<br />
            9.3.2对于在集市平台经营者上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在集市平台注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。<br />

            您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。<br />
            您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
            您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。<br />


            <br /><strong>十、协议的终止</strong><br /><br />
            <strong>10.1 终止的情形</strong> <br />
            10.1.1您有权通过以下任一方式终止本协议：<br />
            （一）在满足集市平台公示的账户注销条件时您通过集市平台自助服务注销您的账户的；<br />
            （二）变更事项生效前您停止使用并书面明示不愿接受变更事项的；<br />
            （三）您明示不愿继续使用集市平台服务，且符合集市平台终止条件的。<br />
            10.1.2出现以下情况时，集市平台经营者可以本协议第九条所列的方式通知您终止本协议：<br />
            （一）您违反本协议约定，集市平台经营者依据违约条款终止本协议的；<br />
            （二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，集市平台经营者依据集市平台规则对您的账户予以查封的；<br />
            （三）除上述情形外，因您多次违反集市平台规则相关规定且情节严重，集市平台经营者依据集市平台规则对您的账户予以查封的；<br />
            （四）其它应当终止服务的情况。<br />
            <strong>10.2 协议终止后的处理</strong> <br />
            10.2.1本协议终止后，除法律有明确规定外，集市平台经营者无义务向您或您指定的第三方披露您账户中的任何信息。<br />
            10.2.2本协议终止后，集市平台经营者仍享有下列权利：<br />
            （一）继续保存您留存于集市平台的本协议第五条所列的各类信息；<br />
            （二）对于您过往的违约行为，集市仍可依据本协议向您追究违约责任。<br />
            10.2.3本协议终止后，对于您在本协议存续期间产生的交易订单，集市可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。<br /><br />


            <strong>十一、法律适用、管辖与其他</strong><br /><br />

            11.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。<br />
            11.2您与集市平台经营者仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇佣与被雇佣或特性授权与被授权关系。<br />
            11.3除双方另有约定外，您同意营客通因经营业务需要有权将本协议项下的权利义务就部分或全部进行转让，并采取合理途径提前通过法定程序以本协议约定的有效方式通知您。<br />
            11.3您因使用集市平台服务所产生及与集市平台服务有关的争议，由集市平台经营者与您协商解决。协商不成时，可向营客通所在地上海市杨浦区人民法院提起诉讼。<br />
            11.3本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。集市平台经营者未就您或其他人士的某项违约行为采取行动，并不表明集市平台经营者撤回就任何继后或类似的违约事件采取行动的权利。<br />
          </p>
        </el-tab-pane> -->
      <el-tab-pane label="自营协议">
        <div style="height: 400px;overflow-y:scroll" class="xy">
          <p>
            <b>营客通自营供应商注册服务协议</b>
          </p>
          <p>欢迎您与营客通平台经营者上海赢可通信息科技有限公司(“营客通平台经营者”或“营客通”)共同签署本《营客通自营供应商注册服务协议》(下称“本协议”)并使用营客通平台服务协议(定义见下文)。</p>
          <p>您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可向营客通平台咨询。</p>
          <p>
            当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，自愿就本协议内容与营客通平台经营者达成一致，并自愿成为营客通平台“供应商”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册注册程序。本协议注册注册完成并由营客通平台发送审核通过信息通知后生效。
          </p>
          <p>一、总则</p>
          <p>第一条
            本着优势互补、互利互惠原则，依据《中华人民共和国协议法民法典》、《中华人民共和国著作权法》、《中华人民共和国产品质量法》、《消费者权益保护法》等法律法规的规定，双方在平等自愿基础上，经友好协商达成一致，签订本协议。
          </p>
          <p>第二条
            双方同时代表各自分公司、子公司、办事处或代理机构（以下通称“关联机构”）。营客通新设立的关联机构在约定的区域设立的关联机构均视为营客通的关联机构，双方在签署本协议时均已获得各自关联机构的授权，双方均有权决定适用本协议的关联机构的增加，但应当书面通知对方，通知到达后生效。双方的关联机构在参与本协议的履行时，享受本协议权利，承担本协议义务。
          </p>
          <p>二、名词解释</p>
          <p>第三条
            商品：由您供应的外观、性能、质量、计量、包装、标识等，符合中国法律法规、行业标准、双方约定标准、厂方/您方承诺及商品包装、说明书、内置宣传物品等承诺，且经生产厂家检验合格的产品，除另有约定，商品含附件、部件、随机文件资料、促销品与相关服务等。
          </p>
          <p>第四条 残次品：指售前、售中或售后发现的产品固有的或发生的不符合第三条约定的商品。</p>
          <p>第五条 工程品：指营客通平台针对价格及付款方式有特殊要求的顾客进行销售的商品。该商品由您以特殊的优惠价格向营客通平台提供。</p>
          <p>第六条
            保荐独销品：指您为激励营客通平台主推您的商品、借助营客通平台推广新品，或因产品渠道区隔以降低恶性价格战风险、集中处理尾货或者滞销品等自身利益原因，而向营客通平台推荐并提供的性能、外观与您的其他规格、型号的商品有明显区别，性能价格有明显优势，在约定期限内，由您提供价格保障的商品。
          </p>
          <p>第七条 零扣点价（一票到底价）：即您以底价供应商品的价格，营客通平台以零折扣向您结算货款的价格（含税）。</p>
          <p>第八条
            名义供价（以下称“供价”）：指您基于市场实际零售价格状况向营客通平台供应商品的建议价格（含税），该价格作为规模返利的计算基准。供价未扣除您应向营客通平台支付的返利，双方根据协议履约实际结算。本协议商品金额按供价算的金额。
          </p>
          <p>第九条 规模返利（以下称“规模返”）：指您对营客通平台销售您的商品在双方约定的期限内达到约定规模给与的销售奖励，以销售额为基础结算。</p>
          <p>第十条 销售数量：营客通平台的客户订单，向您采购/营客通平台ERP向您推送订单商品的数量。销售渠道：上海赢可通信息科技有限公司（营客通APP/小程序）</p>
          <p>第十一条 销售额：销售额=供价*销售数量。</p>
          <p>第十二条 货款：营客通平台客户订单对应的商品采购数量，以当期您供价下的实际销售额，即营客通平台应支付的货款金额。</p>
          <p>第十三条 不可抗力事件：指一方不能预见、不能避免并不能克服的客观情况，致使该方无法履行其在本协议项下义务的事件。不可抗力解释参考《民法典》第一百八十条规定。</p>
          <p>三、商品注册</p>
          <p>第十四条
            您承诺持有中国法律法规要求的一切执照、证件、批准、许可、备案和其他相关文件，以合法从事本协议的相关业务，并在您商品上架前主动向营客通平台提供。您就向营客通平台提供的全部该文件负责，您提供的任一证件、资质文件虚假、缺失、失效的，您应支付营客通平台不少于伍万元违约金，如造成营客通平台损失的，您须赔偿营客通平台由此产生的全部损失。
          </p>
          <p>第十五条
            您承诺所供商品不侵犯任何第三方的合法权利，包括但不限于专利权、商标权、著作权、商号权、技术秘密和商业秘密权等，否则您应支付营客通平台不少于伍万元违约金，如造成营客通平台损失的，您须赔偿营客通平台由此产生的全部损失。
          </p>
          <p>第十六条
            您承诺全权拥有提供给营客通平台销售商品的经营与销售权限，您与品牌方合作近况良好。您应当向营客通平台出具关于销售商品合法销售的文件原件，包括但不限于授权书、合作协议、出产证明、合格证明等文件，否则，您应支付营客通平台不少于伍万元违约金，如造成营客通平台损失的，您须赔偿营客通平台全部损失。
          </p>
          <p>第十七条
            您授权或已征得您相关生产商授权并授权给营客通平台使用您生产商或其商品及本协议涉及的商品的注册标识、照片等用于推广活动有关的广宣材料上，如因此产生纠纷的，由您负责协调并承担全部责任。您提供虚假授权或授权无效以及未取得相关生产商授权等情况，使得营客通平台对外承担任何责任的，您应支付营客通平台不少于伍万元违约金，并须赔偿营客通平台由此产生的全部损失。
          </p>
          <p>第十八条
            如您系生产方，在签订协议时应向营客通平台提交商品的商标专利注册证明文件、商品生产资质证书（如有）；如您属于代理经销商，则需提供品牌厂商出具的完整有效的授权经销证明文件。如营客通平台有其他要求的，您皆应配合提供相关文件。就上述资信文件，您应当根据营客通平台要求向营客通平台出具相关合法有效的原件，或出示真实可信的影印件（加盖公章）。
          </p>
          <p>第十九条 商品包装，您承诺</p>
          <p>1. 符合国家和地方相关规定；</p>
          <p>2. 包装全新、清洁完整、无破损和污染、无任意拆包、重复包装的痕迹；</p>
          <p>3. 储运包装达到运输、储存要求、有防潮、防雨能力</p>
          <p>4. 商品及商品的包装内容不含违反国家法律法规的印刷品、音像制品等物品</p>
          <p>5. 所有代发商品的包装上不允许有任何其他电商平台有关的标志，若营客通平台提供包材，您需根据营客通平台寄送包材按照销售渠道进行包装，否则由您承担相应赔偿责任。</p>
          <p>6. 您提供的商品包装不符合上述承诺，营客通平台或营客通平台客户要求您退货或换货的，您应无条件予以退换货，否则您应支付营客通平台不少于伍万元违约金，并须赔偿营客通平台由此产生的全部损失。</p>
          <p>第二十条 商品质量承诺：</p>
          <p>
            1.您承诺商品全是原装正品，您不得将退货商品、返修商品、非合法渠道商品发货给营客通平台或营客通平台客户；不得将样机充当新机销售、不得将已参加国补后的商品当作未国补商品销售。商品具有该商品通常的使用性能，符合国家规定、行业公认的使用期限以及生产厂家规定（如有）的使用期限，符合保障人体健康、人身、财产要求，取得法律规定强制认证等资质。如您交付商品不符合规定，您应支付涉及商品金额的百分之三十外加不低于壹万元/次违约金；您以样机或者残次机充新机销售的，应支付不低于商品金额的三倍外加不低于10万元/次违约金，并赔偿营客通平台由此产生的全部损失。
          </p>
          <p>
            2.行政机关如需对营客通平台销售的营客通平台供应商商品进行抽检，您应积极协助营客通平台配合有关部门做好采样、索证、样品确认和处理工作。如被行政机关判定不合格、假冒伪劣商品或其他非合格结论的，您除应根据营客通平台要求无条件办理退货外，您同意向营客通平台支付商品总金额的三倍违约金，并承担营客通平台受到行政处罚而遭受的全部损失；如因此造成媒体曝光、群体事件、司法诉讼等，您同意另向营客通平台支付不低于伍万元的商誉损失赔偿。
          </p>
          <p>四、商品供价</p>
          <p>第二十一条
            您商品零扣点价（一票到底价）：即您以底价供应商品的价格，营客通平台以零折扣向您结算货款的价格（含税）。如您为提升促销时间段的阶段性销售，给予营客通平台额外折扣、促销费用等支持，临时约定内容与本协议同等效力，包含不限于双方业务人员微信、邮件等信息传递形式。
          </p>
          <p>五、订单履约</p>
          <p>第二十二条 由您供应营客通平台对外代为销售商品，营客通平台根据客户订单向您提交订单及发货信息，您在收到订单信息（预售/抢单设置的截止时间）24
            小时内完成发货，并将物流信息反馈至营客通平台（未及时发货的订单需在24小时内反馈真实原因，否则将承担平台对客户承诺的补偿，包括但不限于优惠券、补偿金等），该等补偿费用，营客通平台有权直接自您的待结算货款或保证金中扣除。如对交货安排有特殊要求，营客通平台与您可以协商解决。在运输途中如发生货物丢失和损坏的情况，由您负责在收到营客通平台通知的24小时内，按营客通平台要求进行处理并补发。如您超出双方约定发货时效的，营客通平台有权根据届时有效的相关规定进行处理，并要求您承担相应赔偿责任，赔偿范围包括但不限于营客通平台客户取消订单的损失、暂停上架的损失、营客通平台因延误交付或支付造成的经济损失以及临时购买其他替代商品的合理差价。
          </p>
          <p>第二十三条
            双方约定（方式包含不限于文档版/微信/电子邮件等交流信息）后，营客通平台同意您商品进行负卖（即在您无实货在库情况下进行销售并承诺到货时间）。超过承诺时间，您若延迟交货，每逾期一日应向营客通平台支付逾期交货金额的3‰违约金，您若取消交货，应按取消交货金额的30%向营客通平台支付违约金。鉴于已负卖如无法交货或未按约定交货对营客通平台品牌形象造成影响，及因此客诉产生的损失（包括直接损失及间接损失），您应全额予以赔偿。
          </p>
          <p>第二十四条
            营客通平台有权根据平台规则对您延迟发货、虚假发货（如上传虚假、无效物流单号或未实际发货、货物发出后取消发货、货物未在3-7日内进行送达等情形发生，您须在营客通平台通知24小时内退还全部已结算货款，并承担订单金额30%的违约金，且应当另行承担已结算款项的利息损失（按照中国人民银行间同业拆借中心发布的贷款市场报价利率（LPR）的四倍为基准，自支付货款之日起，至实际退款之日时止））、缺货、欺诈发货等违规行为进行处理，相关定义及违规判定、处理方式以本协议及平台规则的规定为准。
          </p>
          <p>第二十五条 您提供的商品必须清洁、整齐、包装完好、适宜销售及长途运输，不得有包装损坏、变色等影响商品正常销售的问题。您交付快递运输的商品应采用适当防护措施，避免商品受到挤压、碰撞而损坏。</p>
          <p>第二十六条 如果双方书面协商确认运费另计的，其运费核算标准不得高于营客通平台与您协商的同水准物流正常标准，否则超出部分由您承担。</p>
          <p>第二十七条 您应该向营客通平台报备其合作的快递或物流公司，所报备的快递或物流公司也应符合平台方要求；并且在其服务达不到营客通平台或营客通平台客户要求的前提下，营客通平台有权要求您更换快递或物流服务公司。</p>
          <p>第二十八条 因您使用的第三方快递或物流服务商导致质量问题、丢件、破损等，您应该立即为营客通平台或营客通平台客户重新配送同等全新的商品，并且承担由此所造成的相关费用及损失。</p>
          <p>第二十九条
            您如未按约定期限交货，营客通平台有权暂停支付相关商品的货款，且不承担延迟付款的任何违约责任。您履约不符合本协议约定的，营客通平台有权要求您在规定时间内整改，如您未能在规定期限内消除违约情形的，营客通平台有权解除本协议，您应赔偿营客通平台由此产生的一切损失。
          </p>
          <p>第三十条 货款结算方式为货到付款，货到付款是指您提供真实有效物流单号，物流进程显示客户签收后，周二、周五付款。</p>
          <p>第三十一条 发票合规性保证与违约责任</p>
          <p>
            营客通平台向您支付全款后，您应于次月10日前向营客通平台开具上月全部货款13%增值税专用发票；如果您未按期开具专用发票，视为您违约。您未按时开票，自逾期之日起应向营客通平台支付应开票金额的日千分之三（3‰）的滞纳金，且由此给营客通平台造成损失的，全部由您进行赔偿。
          </p>
          <p>
            您保证，开具的所有增值税专用发票均合法、真实、有效，且不存在任何可能导致该发票被税务主管机关认定为异常增值税扣税凭证或不得用于抵扣的情形；若因您的原因（包括但不限于税务违法行为、走逃失联、开具发票不规范、被认定为异常户等），导致营客通平台取得的增值税专用发票被税务主管机关认定为异常凭证或不得抵扣，因此被要求进行进项税额转出、补缴增值税款及滞纳金的，该等全部损失（定义见下）均由您承担
          </p>
          <p>损失范围：本条所述“全部损失”包括但不限于：</p>
          <p>(1) 营客通平台被国家税务局要求转出的进项税额及相应补缴的增值税款；</p>
          <p>(2) 因补缴税款所产生的滞纳金；</p>
          <p>(3) 营客通平台为解决此事宜所支付的附加税费（如城市维护建设税、教育费附加等）、律师费、诉讼费、保全费、保全保险费、差旅费等一切合理费用</p>
          <p>
            营客通平台在收到税务部门的《税务事项通知书》或类似文书后，同步通知您；您应在收到营客通平台通知及损失凭证后【10】个工作日内，向营客通平台一次性足额支付全部损失款项。您支付的该等款项系对营客通平台所受损失的赔偿，不属于应税交易对价，营客通平台无需就此向您开具任何发票。营客通平台按本条款向您发出书面通知之日，即视为损失已发生且追偿程序启动。您逾期支付的，每逾期一日，应按应付未付金额的3‰支付滞纳金。本条所述“全部损失”应作最宽泛解释，包括但不限于前述（1）（2）（3）项，以及营客通平台因此遭受的任何其他直接或间接经济损失。
          </p>
          <p>第三十二条
            您授权营客通平台在营客通平台对您的任意一笔或者多笔应付货款中，扣除因您原因产生的应当支付给营客通平台的各种款项，包括但不限于货损、退换货导致的损失、违约金、客户赔偿金及其他各类损失赔偿等。此等扣除货款应当在对账时明确告知您后扣除，您对此无任何异议。
          </p>
          <p>七、售后保证</p>
          <p>第三十三条
            营客通平台及营客通平台客户如在签收后或使用中发现商品存在质量问题，您应根据要求予以维修或调换或退货，并承担运输费用。若营客通平台客户因网上无理由退换货等原因产生退货/换货需求的，您应积极配合执行国家三包法规，进行换货或退还货款，支持七天无理由退/换货需求。
          </p>
          <p>参照三十七、八条，本条不再增加</p>
          <p>第三十四条 您承诺向营客通平台支付售后服务保证金： 0.2
            万元，在您待结算货款余额中扣除。新签约供应商在注册后，暂缓售后服务保证金的缴纳，当月交易额超5万或注册时间达到90天（以先达到其中一项为准），在您待结算货款中扣除。
            如您拒绝承担因产品质量问题对营客通平台及营客通平台客户造成的损失或其他您根据本协议应承担的费用，并拒绝在结算货款时扣除的，营客通平台有权在履约保证金中扣除营客通平台遭受的实际损失或其他您应支付的款项金额，履约保证金不足额的，您应当在10日内补足，不予补足的，营客通平台有权在待结算货款中扣除。
          </p>
          <p>第三十五条
            因您商品订单出现退货退款，营客通平台已向您结算支付该笔货款的，您需于2个工作日内原路退回至营客通平台账户。超时按该笔货款的日千分之五（5‰）收取滞纳金。因商品质量问题导致的客户投诉，您应在2小时内提供解决办法，并立即消除一切不良影响。若因您商品或者品牌等问题所导致的重大/升级投诉，您应该引起高度重视并且在2小时内形成方案书面上报营客通平台；您应该积极配合营客通平台消除不良影响，并且承担因此可能发生的经济赔偿及其他一切损失。
          </p>
          <p>第三十六条 若因投诉率过高（超过1%）导致本商品被终止销售的，营客通平台有权将该款产品下架，您承担给营客通平台造成的订单可得利润损失（以下架前3个月利润为依据）、商誉损失、第三方索赔损失等一切经济损失。</p>
          <p>第三十七条
            对于营客通平台反馈给您的商品售后问题，您需在收到营客通平台问题后2小时内给予营客通平台有效回复。营客通平台客户因您商品质量/运输/错发等问题要求退/换货的，您需在收到退货后24小时内完成查验/退还客户垫付运费工作，48小时内完成补发工作，并同时反馈给营客通平台，营客通平台对此有任何垫付行为的，有权在应结算货款中予以扣除。
          </p>
          <p>第三十八条
            售后问题您给予24小时内及时回复，否则营客通平台有权进行处置，所带来的损失由您全额承担。您未按约定履行售后义务的，应支付营客通平台不少于伍万元违约金，营客通平台对外承担任何责任或遭受损失的，您应予以全部赔偿。</p>
          <p>第三十九条 商品生产安全责任归属于您及生产品牌方。
            因此，如因商品引起任何人身或财产损失，由您及相关品牌方授权营客通平台进行协商，由此产生的一切责任及后果由您承担，如营客通平台已先行承担赔偿责任的，有权向您追偿，亦有权在应结算货款中予以扣除。</p>
          <p>第四十条
            您提供商品及服务违反《产品质量法》、《中华人民共和国广告法》、《中华人民共和国著作权法》、《消费者权益保护法》或其他法律法规，导致的一切责任，由您承担。经证实并产生法律责任的，您承担金钱赔偿之外，如发现造成不良影响，营客通平台有权追溯所有损失，包括合理的商誉损失费，不低于拾万元赔偿。
          </p>
          <p>第四十一条 退换货服务及责任划分</p>
          <p>退货</p>
          <p>营客通平台买家签收后满足七天无理由退货条件（包装完整、配件齐全、未经安装）</p>
          <p>退回产生的费用由营客通平台按正向配送价格承担</p>
          <p>换货</p>
          <p>外包装完好（包括且不限于外包装无破损，无水渍，无油污，无明显凹陷），营客通平台签收后产品外观有损坏或出现质量问题无法正常使用，且营客通平台买家签收后15天内</p>
          <p>换货产生的所有费用由您承担</p>
          <p>八、阳光条款</p>
          <p>第四十二条 营客通平台与您承诺监督并确保各方在业务活动中坚持公平、公开、公正、诚信原则，严格遵守《反不正当竞争法和关于禁止商业贿赂的暂行规定》等法律法规、不为获取交易机会或谋取不正当利益作出违法犯罪行为。</p>
          <p>第四十三条
            营客通平台与您及双方的员工均应尊重对方的商业秘密（包括但不限于软件及与软件有关的全部专利、版权、商标以及其他知识产权保护的程序和文件），并对因与对方合作知晓的对方或与对方合作的第三方的商业秘密及个人客户信息安全等予以保密。不得擅自对合作外第三方泄露或透露与本协议有关及与对方公司有关的商业秘密及个人客户信息。如有违约，造成对方经济损失的，应当承担全部赔偿责任，并支付违约金壹拾万元。若涉及违法，应承担相应法律责任。
          </p>
          <p>第四十四条
            您及其工作人员、代表，以公司或者私人名义（包含与您有关的亲友关系）向营客通平台工作人员直接或者间接赠送礼金、贵重礼品、有价证券、或违反本条任一款、采取其他变相手段提供不正当利益的，视为您违约，营客通平台有权暂停货款支付以及扣除保证金，直至事实查清或者结案，营客通平台不承担任何逾期付款的违约责任。且您应向营客通平台支付违约金按已发生的总提货金额或者销售金额的30%（总提货金额或者销售金额不足壹拾万元的，以壹拾万元为基数）支付。双方代表涉嫌违法犯罪的，移送司法机关处理。
          </p>
          <p>第四十五条
            您不得为扩大您销售规模未经营客通平台同意，在账外私下向营客通平台员工发放销售奖励，名目不限于主推奖励、销售提成、返点提成、达量奖励、好处费、辛苦费等应向营客通平台支付的费用，发放形式包含但不仅限于现金、转账、储值卡等。如您违反该规定，须按照违规金额的10倍向营客通平台支付违约金。
          </p>
          <p>本条所称“其他相关人员”是指甲您经办人以外的与协议有直接或间接利益关系的人员，包括但不仅限于协议经办人的亲友。</p>
          <p>第四十六条
            营客通平台严格禁止营客通平台经办人员的任何商业贿赂行为。营客通平台经办人发生本条第二款所列示的任何一种行为，都是违反营客通平台公司制度的，都将受到营客通平台公司制度和国家法律的惩处。营客通平台监督举报联系方式为：ksaxclient@163.com。
          </p>
          <p>第四十七条 本协议有效期内及终止后，本阳光条款仍长期具有法律效力。</p>
          <p>九、协议解除、终止</p>
          <p>第四十八条 您违反阳光条款的，营客通平台有权单方面终止本协议，并保留追究您法律责任的权力。您积极主动向营客通平台公司提供违反阳光条款的线索的，营客通平台可以不予终止本协议。</p>
          <p>第四十九条
            营客通平台擅自终止协议，营客通平台应与您结清往来账务。您擅自终止协议（包含不限于见营客通平台销售订单不发货行为）应向营客通平台支付所有协议约定的商业折扣、降价补差款、退货款、各项费用及其他您承诺营客通平台的款项，并退还营客通平台多余货款（含各类转货款），并承担终止协议的违约责任（违约金壹拾万元）及所有损失（包括直接及间接损失）
          </p>
          <p>第五十条 协议终止后，您的质保义务、客服及售后服务义务、保密义务和知识产权条款、阳光条款等均应继续履行。</p>
          <p>十、其他约定</p>
          <p>第五十一条
            本协议是双方协议的原则框架约定，双方间的补充协议、服务协议、报价单、订单、确认书、备忘录等应视为本协议的组成部分，共同构成双方有约束力之依据。未经营客通平台书面同意，您不得将其权益义务全部或者部分转让给任何第三方，包含但不限于您将对营客通平台应收账款、其他债权转让、以应收账款申请保理业务等，否则，营客通平台有权解除本协议，如造成营客通平台损失的，您必须赔偿全部损失。
          </p>
          <p>第五十二条
            您与营客通平台如欲继续合作，如协议已到期，但新协议尚未签订，而双方事实上继续合作，本协议有效期自然顺延至新协议签订之日。如果没有签订新协议，在自然顺延期间，双方仍参照本协议执行，在新协议签署后，营客通平台有权选择该顺延期限内适用新协议或本协议。
          </p>
          <p>第五十三条
            本协议有关的一切争议，应协商解决；协商不成的，双方同意将争议交营客通所在地人民法院裁决。如因履行本协议过程中或因实现本协议中的权利所产生的诉讼费、律师费、鉴定费、公告费、调查取证费等一切合理费用均由违约方承担。
          </p>
          <p>第五十四条 鉴于营客通平台商业模式为S2B2C，商户资源作为营客通平台核心商业机密，您郑重承诺；</p>
          <p>1、在商品及发货过程中，不夹带任何与您公司相关的信息，包括但不限于二维码、网址链接、联系方式、价格信息等。</p>
          <p>2、对通过营客通平台产生的销售订单中的商户信息严格保密，不得绕过营客通平台，擅自与平台商户进行联系、交易、撬客户飞单等违规经营行为。</p>
          <p>如违反上述承诺，首次违规平台有权进行全平台公示、扣除服务保证金 2000 元、同时保证金提升至 5000
            元。二次违规：平台有权立即清退、扣除全部保证金。还向营客通平台再支付伍万元违约金；若该金额不足以弥补平台因此遭受的全部损失，营客通平台有权继续追偿不足部分。</p>
          <p>第五十五条
            本协议经您确认，营客通平台审核通过后生效（注册时要确认勾选本协议方可进行下一步，此为您确认，注册供应商账号后，营客通平台采销部门会进行审核，审核后推送信息至您，此为营客通平台审核通过）；未尽事宜，营客通平台与您经协商，可签订补充协议；本协议附件及补充协议与协议具有同等法律效力。
          </p>
          <p>第五十六条 本协议中所约定的货款、赔偿金、违约金等所有金钱给付交易的均以人民币结算。</p>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer" v-if="showBtn">
      <el-button @click="isAgreeVisible = false">取 消</el-button>
      <el-button type="primary" @click="right">同意</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { GetContractCodeByAccount } from '../api/api'
export default {
  name: "",
  props: {
    showBtn: {
      type: Boolean,
      default: true
    },
    account: {
      type: String,
    }
  },
  data() {
    return {
      isAgreeVisible: false,
      contractCode: null
    }
  },
  methods: {
    show() {
      this.contractCode = null
      this.isAgreeVisible = true;
      let acc = this.account.trim()
      if (acc) {
        let name = null
        let userName = null
        if (RegExp(/@/).test(acc)) {
          let index = acc.indexOf('@');
          name = acc.substring(index + 1, acc.length);
          userName = acc.substring(0, index);
        } else {
          name = acc;
          userName = acc;
        }
        GetContractCodeByAccount({ AccountName: userName, TenancyName: name }).then(res => {
          if (res.data.success) {
            this.contractCode = res.data.result
          }
        })
      } else {
        this.contractCode = localStorage.getItem('contractCode')
      }
    },
    hide() {
      this.isAgreeVisible = false;
    },
    right() {
      this.isAgreeVisible = false;
      this.$emit('right')
    },
  }

}
</script>

<style scoped></style>
